import { infiniteQueryOptions, queryOptions } from "@tanstack/react-query";

const API_URL = import.meta.env.VITE_API_URL;

export interface NFT {
	tokenId: string;
	tokenType: string;
	contractAddress?: string;
	balance?: number;
	price: number;
	contract: {
		address: string;
		tokenType: string;
		contractDeployer: string;
		deployedBlockNumber: number;
		// biome-ignore lint/suspicious/noExplicitAny: <explanation>
		openSeaMetadata: Record<string, any>;
		isSpam: boolean;
		spamClassifications: string[];
	};
	image: {
		cachedUrl: string;
		thumbnailUrl: string;
		pngUrl: string;
		contentType: string;
		size: number;
		originalUrl: string;
	};
	raw: {
		tokenUri: string;
		metadata: {
			name: string;
			image_url: string;
			attributes: {
				value: string;
				trait_type: string;
			}[];
		};
	};
	// biome-ignore lint/suspicious/noExplicitAny: <explanation>
	mint: Record<string, any>;
	timeLastUpdated: string;
	// biome-ignore lint/suspicious/noExplicitAny: <explanation>
	acquiredAt: Record<string, any>;
}

export interface GetOwnedNftsResponse {
	ownedNfts: NFT[];
	totalCount: number;
	pageKey?: string;
	validAt: {
		blockNumber: number;
		blockTimestamp: number;
		blockHash: string;
	};
}

export interface GetNftsResponse {
	nfts: NFT[];
	totalCount: number;
	pageKey?: string;
}

interface GetNftsQueryParams {
	collections?: string[];
	user?: string;
	includeMetadata?: boolean;
	pageKey?: string | null;
	pageSize?: number;
}

export const getNftsInfiniteOptions = (
	params?: Omit<GetNftsQueryParams, "pageKey">,
) => {
	return infiniteQueryOptions({
		queryKey: ["nfts", params],
		queryFn: async ({ pageParam }) => {
			const searchParams = new URLSearchParams();

			if (params?.includeMetadata !== undefined) {
				searchParams.set("includeMetadata", params.includeMetadata.toString());
			}
			if (params?.pageSize) {
				searchParams.set("pageSize", params?.pageSize?.toString() ?? "100");
			}
			if (pageParam) {
				searchParams.set("pageKey", pageParam);
			}

			let url = "";
			if (params?.user) {
				if (params?.collections?.length) {
					searchParams.set("collectionAddresses", params.collections.join(","));
				}
				const queryString = searchParams.toString();

				url = `${API_URL}/nfts/user/${params.user}${queryString ? `?${queryString}` : ""}`;
			} else {
				if (params?.collections?.length) {
					searchParams.set("collectionAddress", params.collections.join(","));
				}
				const queryString = searchParams.toString();

				url = `${API_URL}/nfts/contract${queryString ? `?${queryString}` : ""}`;
			}

			const resp = await fetch(url, {
				method: "GET",
				credentials: "include",
			});
			if (!resp.ok) {
				throw new Error("Failed to fetch NFTs");
			}
			const data = (await resp.json()).data;
			return data as GetNftsResponse;
		},
		getNextPageParam: (lastPage: GetNftsResponse) => lastPage.pageKey ?? null,
		initialPageParam: null as string | null,
	});
};

//export interface NftDetail extends NFT {
//	price: number;
//	sellbackPriceInCredits: number;
//	sellbackPriceInUsd: number;
//}

//export const getNftDetailsOptions = (collection: string, tokenId: string) => {
//	return queryOptions({
//		queryKey: ["nfts", "details", collection, tokenId],
//		queryFn: async () => {
//			const resp = await fetch(
//				`${API_URL}/nfts?collectionAddress=${collection}&tokenId=${tokenId}`,
//				{
//					method: "GET",
//					credentials: "include",
//				},
//			);
//			if (!resp.ok) {
//				throw new Error("Failed to fetch NFT details");
//			}
//			return (await resp.json()).data as NftDetail;
//		},
//	});
//};
